export const fieldNames = {
  FORMAT: "FORMAT",
  CATALOGUES: "CATALOGUES",
  PUBLISH: "PUBLISH?",
  DESCRIPTION: "DESCRIPTION",
  TOOL_NAME: "TOOL NAME",
  TAGS: "TAGS",
};
